export default {
    mounted(el, binding) {
        el.classList.add('alpha-feature');

        // Zugriff auf den Komponenten-Kontext (Vue 3 Syntax)
        const instance = binding.instance;

        if (!instance?.$userData?.rights?.accessAlphaFeatures) {
            el.classList.add('hidden');
            el.style.display = 'none';
            el.style.pointerEvents = 'none';
            el.disabled = true;
        }
    },
}